<app-inscription-history
  [period]="currentPeriod"
></app-inscription-history>
